import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import MUIGrid, { GridProps as GridProperties } from '@mui/material/Grid';

type BaseGridProperties = Component.Properties<GridProperties>;

const BaseGrid = forwardRef<
  HTMLElement, BaseGridProperties & StyledGridProperties
>(({
  tag, spacing, outer, ...properties
}, reference) => (
  <MUIGrid
    container
    component={tag ?? 'div'}
    spacing={spacing ?? 4}
    ref={reference}
    {...properties}
  />
));

interface StyledGridProperties {
  outer?: boolean;
}

const Grid = styled(BaseGrid)<StyledGridProperties>`
  box-sizing: border-box;
  &&& {
    padding: ${({ outer }) => (outer ? '0 16px' : '0px')};
    margin: 0 auto 16px;
    width: 100%;
  }
`;

const BaseGridCell = forwardRef<
  HTMLElement, BaseGridProperties & StyledGridCellProperties
>(({
  tag, xs, minHeight, hideIntroTextOnMobile, ...properties
}, reference) => (
  <MUIGrid
    item
    component={tag ?? 'div'}
    xs={xs ?? 12}
    ref={reference}
    {...properties}
  />
));

interface StyledGridCellProperties {
  minHeight?: string; padding?: string; hideIntroTextOnMobile?: boolean;
}

const GridCell = styled(BaseGridCell)<
GridProperties & StyledGridCellProperties
>`
  &&&.MuiGrid-item {
    width: auto;
    ${({ container }) => (container ? 'min-width: calc(100% + 32px);' : '')}
    ${({ minHeight }) => (minHeight ? `min-height: ${minHeight};` : '')}
    ${({ padding }) => (padding ? `padding: ${padding};` : '')}
  }
`;

export {
  BaseGrid,
  Grid,
  GridCell,
};
